import request from './../utils/request'


export function index(params) {
  	return request({
  	  url: '/hours',
  	  method: 'get',
        params
  	})
  }

export function show(id) {
    return request({
      url: `/hours/${id}`,
      method: 'get'
    })
  }

  export function store(data) {
    return request({
      url: '/hours',
      method: 'post',
      data
    })
  }

  export function update(data) {
    return request({
      url: `/hours/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/hours/${id}`,
      method: 'delete',
    })
  }
